export default __webpack_public_path__ + "static/media/whatsapplogo.1ee748db.png";